import { StepProps } from '../common';

import { stepsList } from './steps';
import { StepsSkeleton } from './StepsSkeleton';

export const DisplayStep = ({
  currentStepIndex,
  goToNextStep,
  goToPreviousStep,
}: StepProps) => {
  const Step = stepsList[currentStepIndex]?.component;
  if (!Step) {
    return null;
  }

  return (
    <StepsSkeleton
      goToNextStep={goToNextStep}
      goToPreviousStep={goToPreviousStep}
      currentStepIndex={currentStepIndex}
    >
      <Step />
    </StepsSkeleton>
  );
};
